<h2 md-dialog-title>{{title}}</h2>
<md-dialog-content>{{message}}<hr></md-dialog-content>
<md-dialog-actions>
  <button md-raised-button md-dialog-close color="primary">No</button>
  <button md-raised-button [md-dialog-close]="true" color="accent">Yes</button>
</md-dialog-actions>



// WEBPACK FOOTER //
// ./src/app/modals/confirm/confirm.component.html